// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CERF","tabsBox":"styles_tabsBox__WlnJA","createButton":"styles_createButton__3Ul3i"};